import { FC } from 'react';

type Props = {
	className?: string;
};

const SendIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M6.94687 9.88947H10.594M16.8437 9.94191C16.931 7.58504 5.40135 2.04276 4.31541 3.1428C3.08394 4.39025 6.0282 8.09706 6.6913 9.27744C7.09014 9.98723 7.07915 10.2951 6.62571 11.0042C4.57216 14.2154 3.55346 15.8154 4.18661 16.507C5.19572 17.6094 16.7586 12.242 16.8437 9.94191Z'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
			/>
		</svg>
	);
};

export default SendIcon;
